import React, { useState } from 'react';
import { signIn } from '../../auth/authService';
import { useAuthDispatch } from '../../auth/authContext';
import { SIGN_IN, SIGNING_UP } from '../../auth/authTypes';
import SignInScreen from './screen';
import AppAnalytics, {
  GaCategories,
  GaActions,
} from '../../lib/analytics/Analytics';

const SignInContainer = ({ navigation }) => {
  const dispatch = useAuthDispatch();
  const [signInLoading, setSignInLoading] = useState(false);
  const [signInError, setSignInError] = useState('');

  const signInUser = async (values) => {
    const { email, password } = values;
    const lowerCasedEmail = email.toLowerCase();
    setSignInLoading(true);
    signIn(lowerCasedEmail, password)
      .then((response) => {
        const { attributes, signInUserSession, username } = response;
        const user = {
          email: lowerCasedEmail,
          token: signInUserSession.accessToken.jwtToken,
          userType: attributes['custom:usertype'],
          cognitoId: username,
        };
        AppAnalytics.sendEvent(GaCategories.SIGNIN, GaActions.SIGNIN, 100);
        // FIXME: This is fine for now, but in future set it to entire error class
        setSignInLoading(false);
        dispatch({
          type: SIGN_IN,
          ...user,
        });
      })
      .catch((e) => {
        const { message } = e;
        const isUserNotConfirmed = message.includes('not confirmed');
        if (isUserNotConfirmed) {
          const user = {
            email: lowerCasedEmail,
            password,
          };
          dispatch({ type: SIGNING_UP, ...user });

          return navigation.navigate('VerifyUser', { finishSetup: true });
        }
        const defaultMessage =
          'There was an issue with your credentials, please try again';
        const errorStates = {
          'User does not exist.': 'Your username is incorrect',
          'Incorrect username or password.':
            'Your username or password is incorrect',
        };
        setSignInError(errorStates[message] || defaultMessage);
        setSignInLoading(false);
        console.error(e);
      });
  };

  return (
    <SignInScreen
      navigation={navigation}
      signInError={signInError}
      signInLoading={signInLoading}
      signInUser={signInUser}
    />
  );
};

export default SignInContainer;
